import {
  numericKeyDownHandler,
  positiveIntegerInputHandler,
} from 'module/helpers/input-number-event-handlers';
import { FilterContext } from 'module/types/filter-field/field/field';
import {
  DateFieldFilter,
  DateFieldFilterOperationType,
  DateFieldRelativeFilter,
  RelativeDirection,
} from 'module/types/filter-field/filter/date';
import { Menu } from 'module/ui/components/atoms/dropdown';
import { InputNumber } from 'module/ui/components/atoms/input/input-number';
import { Radio } from 'module/ui/components/atoms/radio';
import { Select } from 'antd';
import { snakeCase } from 'lodash';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Line, Lines } from './components';

const RelativeDirectionSelect = styled(Select)`
  min-width: 96px;
  max-width: 96px;
  margin-left: var(--spacing-03);

  .ant-select-selection-item {
    padding-left: var(--spacing-03);
  }

  .ant-select-arrow {
    right: var(--spacing-03);
  }
`;

const DaysInput = styled(InputNumber)`
  padding-left: var(--spacing-02);
  min-width: 64px;
  max-width: 64px;
  margin-right: var(--spacing-03);

  input {
    text-align: right;
    padding-right: var(--spacing-04);
  }
`;

export const renderRelativeMenuItem = (
  filter: DateFieldFilter,
  type: DateFieldFilterOperationType,
  onChange: (filter: DateFieldFilter) => void,
  getOperationOptionRenderer?: (
    type: DateFieldFilterOperationType,
    filter?: DateFieldFilter,
  ) => null | React.JSX.Element,
  filterContext?: FilterContext,
) => (
  <Menu.Item
    data-cy={`op.${type}`}
    key={type.toString()}
    className="date-criteria"
  >
    <Lines>
      <Line>
        <Radio checked={filter.type === type} />{' '}
        {getOperationOptionRenderer?.(type) ?? (
          <FormattedMessage
            id={`task_list.filters.${snakeCase(
              DateFieldFilterOperationType[type],
            )}`}
          />
        )}
      </Line>
      {filter.type === type && (
        <Line>
          <DaysInput
            data-cy="op.days_input"
            className="date-criteria"
            autoFocus
            min={0}
            max={1095}
            value={(filter as DateFieldRelativeFilter).days}
            onKeyDown={numericKeyDownHandler()}
            onInput={() => positiveIntegerInputHandler(0, 1095)}
            onChange={(value) =>
              onChange({
                ...filter,
                days:
                  value == null || value.toString().trim().length === 0
                    ? undefined
                    : parseInt(value.toString(), 10),
              } as DateFieldFilter)
            }
          />
          <FormattedMessage id="task_list.filters.days" />
          <RelativeDirectionSelect
            className="date-criteria"
            dropdownClassName="date-criteria-selector"
            value={(filter as DateFieldRelativeFilter).direction}
            onChange={(value) =>
              onChange({ ...filter, direction: value } as DateFieldFilter)
            }
          >
            <RelativeDirectionSelect.Option value={RelativeDirection.Ago}>
              <FormattedMessage id="task_list.filters.ago" />
            </RelativeDirectionSelect.Option>
            <RelativeDirectionSelect.Option value={RelativeDirection.FromNow}>
              <FormattedMessage
                id={
                  filterContext === FilterContext.Automations
                    ? 'task_list.filters.from_today'
                    : 'task_list.filters.from_now'
                }
              />
            </RelativeDirectionSelect.Option>
          </RelativeDirectionSelect>
        </Line>
      )}
    </Lines>
  </Menu.Item>
);
